import { render, staticRenderFns } from "./drawLots.vue?vue&type=template&id=5b86e0fa&scoped=true"
import script from "./drawLots.vue?vue&type=script&lang=js"
export * from "./drawLots.vue?vue&type=script&lang=js"
import style0 from "./drawLots.vue?vue&type=style&index=0&id=5b86e0fa&prod&lang=less&scoped=true"
import style1 from "./drawLots.vue?vue&type=style&index=1&id=5b86e0fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86e0fa",
  null
  
)

export default component.exports